import { getLocale } from "../runtime";

const sv_plcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Poland`
};

const plcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_plcountryenglish(inputs)
	return "plCountryEnglish";
};

export { plcountryenglish as "plCountryEnglish" };